import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useMemo } from 'react'
import dayjs from 'dayjs'

export const useIsPublishingPaused = () => {
  const workspace = useCurrentWorkspace()

  return useMemo(() => {
    if (!workspace) return false
    return (
      workspace.pause_autopilot_publish_at ||
      (workspace.resume_autopilot_publish_at && dayjs(workspace.resume_autopilot_publish_at).isAfter(dayjs()))
    )
  }, [workspace])
}
